import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

const ITEMS_PER_PAGE = 'Items per page:';
const NEXT_PAGE = 'Next page';
const PREV_PAGE = 'Previous page';
const FIRST_PAGE = 'First page';
const LAST_PAGE = 'Last page';

@Injectable()
export class PaginatorI18n extends MatPaginatorIntl {
    public constructor(private translate: TranslateService) {
        super();

        this.translate.onLangChange.subscribe(() => {
            this.getAndInitTranslations();
        });
        this.getAndInitTranslations();
    }

    public getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return `0 / ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex: number = page * pageSize;
        const endIndex: number = startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} / ${length}`;
    };

    public getAndInitTranslations = (): void => {
        this.nextPageLabel = this.translate.instant('commons.paginator.NEXT_PAGE');
        this.previousPageLabel = this.translate.instant('commons.paginator.PREV_PAGE');
        this.firstPageLabel = this.translate.instant('commons.paginator.FIRST_PAGE');
        this.lastPageLabel = this.translate.instant('commons.paginator.LAST_PAGE');
        this.itemsPerPageLabel = this.translate.instant('commons.paginator.ITEMS_PER_PAGE');
        this.getRangeLabel = this.getRangeLabel.bind(this);
        this.changes.next();
    };
}
